import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import { getApplicationsData } from "../../../../../api";
import useDashboardStore from "../../../../stores/dashboard";
import SkeletonLoader from "../../../../components/skeleton-loader";

const Applications = () => {
  const filterDataStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterDataEndDate = useDashboardStore((s) => s.filterData.endDate);
  const filterUser = useDashboardStore((s) => s.filterData.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterData.filterOrg);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getApplicationsData({
      first_date: filterDataStartDate,
      end_date: filterDataEndDate,
      user_id: filterUser,
      org_id: filterOrg,
    }).then((res) => {
      if (res.status) {
        setApplicationsData(res.data);
        let total = res.data.reduce((acc, item) => acc + item.value, 0);
        setBarData(
          res.data.map((item, index) => ({
            title: item.title,
            barPercentage: ((item.value / total) * 100).toFixed(2),
            color: item.color,
          })),
        );
        setLoading(false);
      }
    });
  }, [filterDataStartDate, filterDataEndDate, filterUser, filterOrg]);

  const [applicationsData, setApplicationsData] = useState([]);
  const [barData, setBarData] = useState([
    {
      title: "New Lead",
      barPercentage: 95,
      color: "#400006",
    },
    {
      title: "App in progress",
      barPercentage: 1,
      color: "#E3B8FC",
    },
    {
      title: "Signed",
      barPercentage: 1,
      color: "#004CA3",
    },
    {
      title: "Underwriting",
      barPercentage: 1,
      color: "#FCFFAC",
    },
    {
      title: "Approved",
      barPercentage: 1,
      color: "#19A81E",
    },
    {
      title: "Declined",
      barPercentage: 1,
      color: "#E15E5E",
    },
  ]);

  return (
    <div className={styles.applications}>
      <div className={styles.applicationsHeader}>
        <p className={styles.applicationsHeaderTitle}>Applications</p>
        <p className={styles.applicationsHeaderDate}>
          {new Date(filterDataStartDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })} - {new Date(filterDataEndDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}
        </p>
      </div>

      <div className={styles.barContainer}>
        {loading && (
          <SkeletonLoader
            variant="rectangular"
            height={"7px"}
            width={"100%"}
            style={{
              borderRadius: "8px",
            }}
          />
        )}

        {!loading &&
          barData.map((bar, index) => (
            <div
              key={index}
              className={styles.bar}
              style={{ width: `${bar.barPercentage}%`, background: bar.color }}
            ></div>
          ))}
      </div>

      {loading && (
        <div className={styles.applicationsList}>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={styles.applicationsListItem}>
              <div className={styles.indicatorContainer}>
                <SkeletonLoader
                  variant="circular"
                  height={"8px"}
                  width={"8px"}
                />
              </div>

              <div
                className={styles.applicationsListItemContent}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                }}
              >
                <SkeletonLoader
                  variant="rectangular"
                  height={"16px"}
                  width={"100%"}
                  style={{
                    borderRadius: "8px",
                  }}
                />
                <SkeletonLoader
                  variant="rectangular"
                  height={"16px"}
                  width={"40%"}
                  style={{
                    borderRadius: "8px",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && (
        <div className={styles.applicationsList}>
          {applicationsData.map((application, index) => (
            <div key={index} className={styles.applicationsListItem}>
              <div className={styles.indicatorContainer}>
                <span
                  className={styles.indicatorDot}
                  style={{ background: application.color }}
                ></span>
              </div>

              <div className={styles.applicationsListItemContent}>
                <p className={styles.applicationsListItemTitle}>
                  {application.title}
                </p>
                <p className={styles.applicationsListItemDate}>
                  {application.percentage}% of all applications
                </p>
              </div>

              <div className={styles.numberContainer}>
                <p className={styles.numberValue}>{application.value}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Applications;
